<template>
  <el-dialog
    :title="setId?'编辑账户':'新增账户'"
    :visible.sync="orgDialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    width="600px"
    center>
    <el-form :model="orgForm" :rules="rules" ref="orgForm" label-width="150px">
      <el-form-item label="社会组织名称" prop="org">
        <el-input v-model="orgForm.org" placeholder="请输入社会组织名称"></el-input>
      </el-form-item>
      <el-form-item label="统一社会信用代码" prop="code">
        <el-input v-model="orgForm.code" placeholder="请输入统一社会信用代码"></el-input>
      </el-form-item>
      <el-form-item label="联系人" prop="name">
        <el-input v-model="orgForm.name" placeholder="请输入联系人"></el-input>
      </el-form-item>
      <el-form-item label="手机号码" prop="phone">
        <el-input v-model="orgForm.phone" placeholder="请输入联系人手机号码"></el-input>
      </el-form-item>
      <el-form-item class="flex align-center justify-around" label-width="0">
        <el-button class="padding-lr-xl" @click="resetForm('orgForm')">取消</el-button>
        <el-button class="padding-lr-xl" type="primary" @click="submitForm('orgForm')">提交</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import rules from '@/utils/rules'
import {orgSave} from "@/api/admin";

export default {
  name: "orgDialog",
  props: {
    orgDialog: {
      type: Boolean,
      default: false
    },
    setId: {
      type: Number,
      default() {
        return 0;
      }
    },
    setItem: {
      type: Object
    }
  },
  data() {

    return {
      power: 0,
      orgForm: {
        org: '',
        code: '',
        name: '',
        phone: '',

      },
      xiaoqu: [],
      rules: {
        org: [{required: true, message: '请输入社会组织名称', trigger: 'blur'}],
        code: [{required: true, message: '请输入统一社会信用代码', trigger: 'blur'},
          {min: 18, max: 18, message: '统一社会信用代码长度为18位', trigger: 'blur'}],
        name: [{required: true, message: '请输入联系人', trigger: 'blur'}],
        phone: rules.phone,
      }
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },

  },
  created() {

  },
  methods: {

    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$emit('cancelDialog', false)
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitData(formName)
        }
      });
    },
    async submitData(formName) {
      let _state = await orgSave(
        this.orgForm.org,
        this.orgForm.code,
        this.orgForm.name,
        this.orgForm.phone,
        this.setId ? this.setId : '',
      );
      this.$message.success(_state.info);
      this.$refs[formName].resetFields();
      this.$emit("cancelDialog", true);
    }
  },
  watch: {
    setItem() {
      this.orgForm = {
        org: this.setItem.title,
        code: this.setItem.credit_code,
        name: this.setItem.name,
        phone: this.setItem.phone,
      };
    },
  }
}
</script>

<style scoped lang="scss">

</style>
